import PropTypes from "prop-types";
import ProcessRow from "../ProcessRow";

export default function ProcessRowBetoni(props) {
  const show = props.show === undefined ? true : props.show;
  if (!show) return null;

  const thisProcess = props.thisProcess;
  const isConfirmed = props.thisProcess.betoniVarattu.isConfirmed;
  const confirmDate = props.thisProcess.betoniVarattu.confirmDate;

  function handleKlik() {
    if (thisProcess.betoniVarattu.isConfirmed) thisProcess.betoniHylkää();
    else thisProcess.betoniHyväksy();
    thisProcess.betoniVarattu.isConfirmed = !isConfirmed;
    props.setThisProcess(thisProcess);
  }

  function getTip() {
    if (thisProcess.isImported.isConfirmed)
      return "Tilaus on tuotu ulkoisesta järjestelmästä. Betoni on oletuksella varattu.";
    return isConfirmed
      ? "Poista merkintä että betoni on varattu tilausta varten"
      : "Merkitse että betoni on varattu tilausta varten";
  }
  return (
    <ProcessRow
      txt="Betoni varattu"
      checkTip={getTip()}
      done={isConfirmed}
      pvm={confirmDate}
      onClick={() => handleKlik()}
      aria-label="Betoni varattu"
      disableTextClick
      disableCheckClick={thisProcess.isImported.isConfirmed}
      helpId="processRowBetoniVarattu"
      show={show}
    />
  );
}

ProcessRowBetoni.propTypes = {
  thisProcess: PropTypes.object,
  setThisProcess: PropTypes.func,
  show: PropTypes.bool,
};
